module.exports = "pegasus/assets/blocks/social-1-theme5.png";